import { MbeCheck } from '@/components/icons';
import { Loader } from '@/components/shared';
import { ROUTE_PATHS } from '@/constants';
import type { IAuthFormFields, IBaseForm } from '@/types';
import { Auth } from '@aws-amplify/auth';

import { Flex, Icon, Text, Button } from '@chakra-ui/react';
import { Suspense } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { Section } from '../components/Section';
import { PlainLayout } from '../layout';

export const UserSignUpConfirmation: React.FC<IBaseForm<IAuthFormFields>> = (): JSX.Element => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const activationCode: string | null = searchParams.get('code');
  const username: string | null = searchParams.get('email');

  if (username && activationCode) {
    const confirmSignUp = async (username: string, code: string): Promise<void> => {
      try {
        await Auth.confirmSignUp(username, code);
      } catch (error) {
        console.log('error confirming sign up', error);
      }
    };

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    confirmSignUp(username, activationCode);
  }

  return (
    <PlainLayout>
      <Suspense fallback={<Loader />}>
        <Section
          containerProps={{ py: 0, gap: { base: 8, md: 16 } }}
          headingProps={{ mt: 0 }}
          id="signup-success-section"
        >
          <Flex
            alignItems="center"
            direction="column"
            gap={6}
            px={{ base: 8, md: 16, xl: 44 }}
            py={{ base: 0, md: 24 }}
          >
            <Icon as={MbeCheck} h={24} w={24} />
            <Text
              fontSize={{ base: 'h1.base', md: 'h1.mb' }}
              fontWeight="bold"
              maxW={{ base: '100%', md: '55%' }}
              textAlign="center"
            >
              <Trans i18nKey={'SIGNUP.SIGNUP_SUCCESS_MESSAGE_TITLE'} />
            </Text>
            <Text
              fontSize={{ base: 'p.base', md: 'p.mb' }}
              maxW={{ base: '100%', md: '55%' }}
              textAlign="center"
            >
              <Trans i18nKey={'SIGNUP.SIGNUP_SUCCESS_MESSAGE_TEXT'} />
            </Text>
            <Button as="a" href={`${ROUTE_PATHS.landing}`} my={6} variant="mbePrimary">
              {t('SIGNUP.SIGNUP_SUCCESS_BUTTON_TEXT')}
            </Button>
          </Flex>
        </Section>
      </Suspense>
    </PlainLayout>
  );
};
